module.exports = __webpack_public_path__ + "img/exit.17c03c77.svg";